/* V23: pause animated review/trust strips during touch, then resume.
   Never touches ordering, conversion, prices or external integrations. */
(function(){
  function init(){
    var rails=document.querySelectorAll('.v23-homereviews__scroller,.v23-trust');
    if(!rails.length)return;
    var observer=null;
    if('IntersectionObserver' in window){
      observer=new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          e.target.classList.toggle('vq23-rail-offscreen',!e.isIntersecting);
        });
      },{rootMargin:'75px 0px'});
    }
    Array.prototype.forEach.call(rails,function(rail){
      if(rail.dataset.vq23MotionReady==='1')return;
      rail.dataset.vq23MotionReady='1';
      var resumeTimer=null;
      function hold(){
        if(resumeTimer)window.clearTimeout(resumeTimer);
        rail.classList.add('vq23-rail-held');
      }
      function release(){
        if(resumeTimer)window.clearTimeout(resumeTimer);
        resumeTimer=window.setTimeout(function(){rail.classList.remove('vq23-rail-held');},1800);
      }
      rail.addEventListener('pointerdown',hold,{passive:true});
      rail.addEventListener('pointerup',release,{passive:true});
      rail.addEventListener('pointercancel',release,{passive:true});
      rail.addEventListener('touchstart',hold,{passive:true});
      rail.addEventListener('touchend',release,{passive:true});
      rail.addEventListener('touchcancel',release,{passive:true});
      if(observer)observer.observe(rail);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
